import { AnimateContext, AnimateDirection } from '@src/contexts';
import { usePresence } from 'framer-motion';
import { usePrevious } from 'pe-core-frontend';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
export const StableOutlet = () => {
    const o = useOutlet();
    const [outlet] = useState(o);
    const [isPresent, safeToRemove] = usePresence();
    const { setAnimateDirection } = useContext(AnimateContext);
    const location = useLocation();
    const previousPath = usePrevious(location.pathname);
    useEffect(() => {
        if (!isPresent) {
            safeToRemove();
        }
        else if (previousPath !== location.pathname) {
            // reset the direction on path changes
            setAnimateDirection(AnimateDirection.RTL);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPresent, location.pathname, previousPath]);
    return outlet;
};
